module.exports = __webpack_public_path__ + "static/img/dllogogb.63e2e72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/dllogogb.jpg
// module id = KU5x
// module chunks = 2